import { useSelector } from 'react-redux';

import {
  getKnmIsCommonWatchOnly,
  getKnmIsEditableInStatusCommentsExist,
  getKnmIsErknmStatusCommentsExist,
  getKnmIsErknmStatusFillInProcess,
  getKnmIsErknmStatusReadyForApprove,
  getKnmIsErknmStatusRejectAppealed,
  getKnmIsErknmStatusTypeCarriedOut,
  getKnmIsErknmStatusTypeWaitingCarryOut,
  getKnmIsNew,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { getPlanListPlanErknmStatus } from '../../../PlanListPackage/MainModule/selectors/planListSelectors';
import { getIsPlanErknmStatusUnderConsideration } from '../../../APIPackage/PlanListModule/common/getPlanErknmStatusFlags';
import { useHasFieldApproveRemark } from '../common/useHasFieldApproveRemark';
import { ErknmApproveRemarkSectionCodeEnum } from '../../ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';

export const isExpertsEnabled = (): boolean => {
  const isCommonWatchOnly = useSelector(getKnmIsCommonWatchOnly);
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const isKnmNew = useSelector(getKnmIsNew);
  const isKnmStatusFillInProcess = useSelector(getKnmIsErknmStatusFillInProcess);
  const isKnmStatusReadyForApprove = useSelector(getKnmIsErknmStatusReadyForApprove);
  const isKnmStatusTypeWaitingCarryOut = useSelector(getKnmIsErknmStatusTypeWaitingCarryOut);
  const isKnmStatusTypeCarriedOut = useSelector(getKnmIsErknmStatusTypeCarriedOut);
  const isKnmStatusRejectAppealed = useSelector(getKnmIsErknmStatusRejectAppealed);
  const isKnmStatusCommentsExist = useSelector(getKnmIsErknmStatusCommentsExist);
  const knmPlanStatus = useSelector(getPlanListPlanErknmStatus);
  const isKnmPlanStatusUnderConsideration = getIsPlanErknmStatusUnderConsideration(knmPlanStatus);
  const isAvailableInStatusCommentsExist = useSelector(getKnmIsEditableInStatusCommentsExist);
  const isRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.EXPERTS);

  return (
    !isCommonWatchOnly &&
    isSupervisor &&
    !isKnmPlanStatusUnderConsideration &&
    (isKnmNew ||
      isKnmStatusFillInProcess ||
      isKnmStatusReadyForApprove ||
      isKnmStatusTypeWaitingCarryOut ||
      isAvailableInStatusCommentsExist ||
      (isKnmStatusCommentsExist && isRemarksExists) ||
      isKnmStatusTypeCarriedOut ||
      isKnmStatusRejectAppealed)
  );
};
